import { useQuery } from "@tanstack/react-query";
import { ApiGetFortAgentSkuConfig } from "@/api";

export function useFortAgentSkuConfig() {
  return useQuery({
    queryKey: ["fortAgentSkuConfig"],
    queryFn: async () => {
      const res = await ApiGetFortAgentSkuConfig();
      console.log("useFortAgentSkuConfig", res.data);
      return res.data;
    },
    refetchInterval: 3000,
    retry: 3,
  });
}
